export default [
  // 'Under Review',
  // 'Paused',
  // 'Hold',
  // 'Rejected',
  // 'Completed',
  // 'Scheduled',
  // 'Out Of Budget',
  'Active',
  'Inactive'
]
